export enum CommonButtonSize {
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Middle = 'middle',
  Large = 'large',
}

export enum CommonButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum CopySize {
  Small = 'small',
  Normal = 'normal',
  Big = 'big',
}
